import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table  } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { 
  approvalTimerColumns, 
} from "utils/columns/Dashboard/dashboardColumns"
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchPostData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { customGlobalFilter } from "utils/common-helpers" 
import {
  timeSheetApprovalColumns, 
} from "utils/columns/ElementsColumns/supportColumns"

function TableContainer({
  columns,
  data,
  members,
  toggleLoading,
  tab,
  tabs,
  setTab,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => {
    setPageSize(10)
  }, [])
  // Render the UI for your table

  const [fixedHeading, setFixedHeading] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 40) {
      setFixedHeading(true)
    } else {
      setFixedHeading(false)
    }
  })

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body ">
            <Row className="justify-content-between align-items-center">
              <div className="text-purple fw-bold fs-5 col-md-6 d-flex gap-4">
                {tab + " Approval"}

                <div className=" d-flex gap-3">
                  {tabs.map(tb => (
                    <div
                      key={tb}
                      onClick={() => setTab(tb)}
                      style={{ userSelect: "none", fontSize: "12px" }}
                      className={`d-flex gap-1 align-items-center fw-semibold general-box border py-0 px-2 rounded ${
                        tb === tab ? "bg-purple" : "bg-light"
                      }`}
                    >
                      <span style={{ lineHeight: "25px" }}>{tb}</span>
                      {tb === tab && (
                        <h5 className="text-primary mb-0">: {data.length}</h5>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-5 cusrtom_search_box d-flex align-items-center gap-3">
                <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                  <div className="d-flex">
                    <div className="position-relative w-100">
                      <label
                        htmlFor="search-bar-0"
                        className="search-label w-100 mb-0"
                      >
                        <span id="search-bar-0-label" className="sr-only">
                          Search this table
                        </span>
                        <input
                          onChange={e => setGlobalFilter(e.target.value)}
                          id="search-bar-0"
                          type="text"
                          className="border-radius form-control rounded h-100 w-100"
                          placeholder={`Search...`}
                          value={globalFilter || ""}
                        />
                      </label>
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <select
                    className="border-radius form-select "
                    style={{ width: "100px" }}
                    value={pageSize}
                    onChange={e => setPageSize(e.target.value)}
                  >
                    {[10, 25, 50, 100].map(pageSize => (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </Row>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className={`fixed_view_payment_table`}>
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1  header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="fix-introducer-header"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row)
                    const rowBackgroundColor =
                      row?.original?.leave_type == 2
                        ? "bg-light-red2"
                        : "bg-white"

                    return (
                      <tr
                        className={`row-hover ${rowBackgroundColor}`}
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              className={`t-col-${index + 1} ${
                                cell.column.className
                              }`}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const ApprovalTimer = () => {
  const [modal_Access, setAccessDenied] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const token = secureLocalStorage.getItem("auth_token")

  // const tabs = ["Timer", "Task Delay", "Other Tasks"]
  const tabs = ["Timer", "Timesheet Task"]

  const [tab, setTab] = useState(tabs[0])

  const toggleLoading = loading => {
    setLoading(loading)
  }

  const getData = async () => {
    const user_id = localStorage.getItem("auth_id") // 20
    const response = await fetchData(
      toggleLoading,
      `approveTaskTimerData/${user_id}`,
      token
    )
    if (response?.success) {
      setData(response.data)
    }
  }

  const getDelayData = async () => {
    const user_id = localStorage.getItem("auth_id")
    const response = await fetchNodeData(
      toggleLoading,
      `delayApproval/${user_id}`,
      token
    )
    if (response?.success) {
      setData(response.data)
    }
  }

  const getPendingData = async () => {
    const response = await fetchNodeData(
      toggleLoading,
      `pendingTasks/approval/${localStorage.getItem("auth_id")}`,
      token
    )
    if (response?.success) {
      console.log("pending tasks",response.data)
      setData(response.data)
    }
  }

  useEffect(() => {
    setData([])

    switch(tab){
      case tabs[0]: getData(); break;
      case tabs[1]: getPendingData(); break;
      // case tabs[2]: getPendingData(); break;
    }

    // tab === tabs[0]
    //   ? getData()
    //   : tab === tabs[1]
    //   ? getDelayData()
    //   : getPendingData()

    
  }, [tab])

  const onApprove = (type, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to  ${
        type == 1 ? "Approve" : "Disapprove"
      } this request?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, do it!",
      cancelButtonText: "No, cancel!",
    }).then(async result => {
      if (result?.isConfirmed) {
        const formEntries = {
          timer_id: id,
          user_id: localStorage.getItem("auth_id"),
          type: type,
          process_type: status == 2 ? 1 : status == 3 ? 2 : null,
        }
        const res = await FetchPostData(
          toggleLoading,
          "approveTaskTimerDetails",
          token,
          formEntries
        )
        if (res?.data?.success) {
          Swal.fire({
            icon: "success",
            title: `Timer ${type == 1 ? "Approve" : "Disapprove"} Successfully`,
          }).then(() => {
            try {
              setData(res?.data?.data)
            } catch (error) {
              console.error("error: ", error)
            }
          })
        }
      }
    })
  }
  
  const onPendingApprove = (type, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to  ${
        type == 1 ? "Approve" : "Disapprove"
      } this request?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, do it!",
      cancelButtonText: "No, cancel!",
    }).then(async result => {
      if (result?.isConfirmed) {
        const formEntries = {
          id,
          type,
        }
        const res = await FetchNodePostData(
          toggleLoading,
          "pendingTasks/approval",
          token,
          formEntries
        )
        console.log("resssss: ", res)
        if (res?.data?.success) {
          Swal.fire({
            icon: "success",
            title: `Other Task ${
              type == 1 ? "Approve" : "Disapprove"
            } Successfully`,
          }).then(() => {
            // setData(res?.data?.data)
            getPendingData()
          })
        }
      }
    })
  }

  const onDelayApprove = (taskId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${
        status == 1 ? "approve" : "disapprove"
      } this request?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, do it!",
      cancelButtonText: "No, cancel!",
    }).then(async result => {
      if (result?.isConfirmed) {
        const formEntries = {
          task_id: taskId,
          status,
        }
        const res = await FetchNodePostData(
          toggleLoading,
          "delayApproval",
          token,
          formEntries
        )
        if (res?.data?.success) {
          Swal.fire({
            icon: "success",
            title: `Request ${
              status == 1 ? "Approved" : "Disapproved"
            } Successfully`,
          }).then(() => {
            try {
              setData(prev => prev.filter(item => item.id != taskId))
            } catch (error) {
              console.error("error: ", error)
            }
          })
        }
      }
    })
  }

  const column1 = useMemo(() => {
    //  || tab === tabs[1]
    return tab === tabs[0]
      ? approvalTimerColumns(onApprove)
      : timeSheetApprovalColumns(onPendingApprove)
  }, [tab])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="">
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <div className="responsive-table">
                  {/* <div className="p-3 pb-0 d-flex gap-3">
                    {tabs.map(tb => (
                      <div
                        key={tb}
                        onClick={() => setTab(tb)}
                        style={{ userSelect: "none" }}
                        className={`d-flex gap-1 align-items-center general-box border py-1 px-3 rounded ${
                          tb === tab ? "bg-purple" : "bg-light"
                        }`}
                      >
                        <strong style={{ lineHeight: "25px" }}>{tb}</strong>
                        {tb === tab && (
                          <h5 className="text-primary mb-0">: {data.length}</h5>
                        )}
                      </div>
                    ))}
                  </div> */}
                  <TableContainer
                    columns={column1}
                    data={data}
                    toggleLoading={toggleLoading}
                    tab={tab}
                    tabs={tabs}
                    setTab={setTab}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default ApprovalTimer
